import script from "./LandingTasksTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingTasksTable.vue?vue&type=script&setup=true&lang=js"

import "./LandingTasksTable.vue?vue&type=style&index=0&id=d5f82942&lang=scss"

const __exports__ = script;

export default __exports__